<template>
  <div class="container">
    <div class="header">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#ffffff"
          @click="onClickHeaderReturn()"
      />
      Current Settings
    </div>
    <div class="content">
      <div class="setting-model">
        <button
            class="model-button"
            :class="selectModel === 'Wave Writer' ? 'model-button-active' : ''"
            style="margin-right:8px;"
            @click="onClickSelectModel('Wave Writer')"
        >
          Wave Writer
        </button>
        <button
            class="model-button"
            :class="selectModel === 'Device' ? 'model-button-active' : ''"
            style="margin-left:8px;"
            @click="onClickSelectModel('Device')"
        >
          Device
        </button>
      </div>
      <!-- Hub模式 -->
      <div v-show="selectModel === 'Wave Writer'" style="overflow-y: auto;">
        <div
            v-if="
            hubOutputMode === 0 ||
              hubOutputMode === 0x10 ||
              hubOutputMode === 0x20
          "
        >
          <!-- Info -->
          <div class="info-item">
            <div class="info-title">Hub Info</div>
            <div class="item-split"></div>
            <div class="info-content">
              <InfoRow left="Device Model" right="VIA hub"/>
              <InfoRow left="S/N" :right="macAddress.replace(/:/g, '')"/>
            </div>
          </div>
          <!-- Preheat -->
          <div class="info-item" v-if="false">
            <div class="info-title">
              Preheat
              <van-switch
                  style="margin-left:auto;"
                  v-model="hubSetting.isSupportPreheat"
                  active-color="#66DCA5"
                  inactive-color="#D6CDF2"
                  size="18"
                  :disabled="true"
              />
            </div>
            <div class="item-split" v-show="false"></div>
            <div class="info-content" v-show="false">
              <InfoRow
                  left="Time"
                  :right="(hubSetting.preheatTime / 1000).toFixed(1) + 's'"
              />
              <InfoRow
                  left="Voltage"
                  :right="(hubSetting.preheatVoltage / 1000).toFixed(1) + 'v'"
              />
            </div>
          </div>
          <!-- Voltage -->
          <div class="info-item">
            <div class="info-title">Voltage Curve</div>
            <div class="item-split"></div>
            <div class="info-content">
              <div class="voltage-one">
                <div
                    class="voltage-number"
                    v-for="(item, index) in hubVoltage.slice(0, voltageCount)"
                    :key="index"
                >
                  <span v-if="hubOutputMode === 0x20">
                    {{ Math.abs(item / 100).toFixed(1) }} {{ hubInfo.unitName }}
                  </span>
                  <span v-else>
                    {{ Math.abs(item / 1000).toFixed(1) }}
                    {{ hubInfo.unitName }}
                  </span>
                </div>
              </div>
              <div
                  id="voltageTwo"
                  class="voltage-two"
                  style="width:100%;height:calc(20vh)"
              >
                <van-slider
                    v-for="(value, index) in hubVoltage.slice(0, voltageCount)"
                    :key="index"
                    v-model="hubVoltage[index]"
                    vertical
                    :min="hubInfo.dragValue.max"
                    :max="hubInfo.dragValue.min"
                    :step="hubInfo.dragValue.step"
                    bar-height="4px"
                    active-color="#EEEEEE"
                    inactive-color="#D6CDF2"
                    :disabled="true"
                >
                  <template #button>
                    <img
                        class="slider-button"
                        src="@/assets/icons/icon_slider_button_disabled.png"
                    />
                  </template>
                </van-slider>
              </div>
              <div class="voltage-three" v-if="false">
                <div class="voltage-number" v-for="index of voltageCount" :key="index">
                  {{ index }}s
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="hubOutputMode === 0x40">
          <!-- Info -->
          <div class="info-item">
            <div class="info-title">Hub Info {{ supportTripleCartridge }}</div>
            <div class="item-split"></div>
            <div class="info-content" v-if="supportTripleCartridge">
              <InfoRow left="Device Model" right="VIA hub"/>
              <InfoRow left="S/N" :right="macAddress.replace(/:/g, '')"/>
              <InfoRow
                  v-if="showInfoIfExistsR1"
                  left="Push Power"
                  :right="`${hubSetting.micSensitivity.toFixed(2)}W`"
              />
              <!--        Left Base R1      -->
              <InfoRow :left="r1Title" :right="`${r1}Ω`"/>
              <!--        Left R2      -->
              <InfoRow
                  v-if="showInfoIfExistsR1"
                  :left="r2Title"
                  :right="hubR2Value"
              />
              <!--        Left Temperature      -->
              <InfoRow
                  v-if="showInfoIfExistsR1"
                  left="Temperature"
                  :right="`${calcT2(r1, hubLeftR2 / 1000)}°C`"
              />

              <!--        Center Base R1      -->
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  :left="centerR1Title"
                  :right="`${centerR1}Ω`"
              />
              <!--        Center R2      -->
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  :left="centerR2Title"
                  :right="`${(tripleHubCenterR2 / 1000 + centerR1).toFixed(3)}Ω`"
              />
              <!--        Center Temperature      -->
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  left="Temperature"
                  :right="`${calcT2(centerR1, tripleHubCenterR2 / 1000)}°C`"
              />

              <!--        Right Base R1      -->
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  :left="doubleR1Title"
                  :right="`${rightR1}Ω`"
              />
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  :left="doubleR2Title"
                  :right="`${(tripleHubRightR2 / 1000 + rightR1).toFixed(3)}Ω`"
              />
              <InfoRow
                  v-if="showInfoIfExistsDoubleR1Triple"
                  left="Temperature"
                  :right="`${calcT2(rightR1, tripleHubRightR2 / 1000)}°C`"
              />
              <div
                  v-if="!showInfoIfExistsR1"
                  style="font-size:16px;font-weight: bold"
              >
                Please Read device to get base r
              </div>
            </div>
            <div  v-else>
              <div class="info-content">
                <InfoRow left="Device Model" right="VIA hub"/>
                <InfoRow left="S/N" :right="macAddress.replace(/:/g, '')"/>
              </div>
              <div class="info-content">
                <InfoRow v-if="showInfoIfExistsR1" left="Push Power" :right="`${(hubSetting.diyVoltage[2] / 100).toFixed(2)}W`"/>
                <!--      Left Base R1        -->
                <InfoRow :left="r1Title" :right="`${r1}Ω`"/>
                <!--      Left Base R2        -->
                <InfoRow v-if="showInfoIfExistsR1" :left="r2Title" :right="hubR2Value"/>
                <!--        Left Temperature      -->
                <InfoRow v-if="showInfoIfExistsR1" left="Temperature1" :right="`${calcT2(r1, hubLeftR2 / 1000)}°C`"/>
              </div>



              <div class="info-content">
                <InfoRow v-if="showInfoIfExistsDoubleR1" left="Push Power" :right="`${(hubSetting.diyVoltage[5] / 100).toFixed(2)}W`"/>

                <!--         Right Base R1       -->
                <InfoRow v-if="showInfoIfExistsDoubleR1" :left="doubleR1Title" :right="`${doubleR1}Ω`"
                />
                <!--      Right  R2        -->
                <InfoRow v-if="showInfoIfExistsDoubleR1" :left="doubleR2Title" :right="`${(hubRightR2 / 1000 + doubleR1).toFixed(3)}Ω`"
                />

                <!--        Right Temperature      -->
                <InfoRow v-if="showInfoIfExistsDoubleR1" left="Temperature2" :right="`${calcT2(doubleR1, hubRightR2 / 1000)}°C`"/>
              </div>



              <div v-if="!showInfoIfExistsR1" style="font-size:16px;font-weight: bold">
                Please Read device to get base r
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Device模式 -->
      <div v-show="selectModel === 'Device'" style="overflow-y: auto;">
        <div v-if="loadDeviceSettingStatus === 1">
          <div v-if="outputMode === 0 || outputMode === 0x10 || outputMode === 0x20">
            <!-- Info -->
            <div class="info-item">
              <div class="info-title">Device Info</div>
              <div class="item-split"></div>
              <div class="info-content">
                <InfoRow left="Device Model" :right="insertDeviceName"/>
                <InfoRow left="ID" :right="deviceIdentify"/>
                <InfoRow v-if="deviceType" left="Device Type" :right="deviceType"/>
                <InfoRow left="Resistance" :right="`${resistance}Ω`"/>
                <InfoRow left="Production Time" :right="productTime"/>
                <InfoRow left="Brand" :right="brandName"/>
                <InfoRow v-if="supportOutputDuration" left="Output Duration" :right="outputDuration"/>
                <InfoRow v-if="supportLevel" left="Level" :right="writerSetting.touchSensitivity + 1"/>
                <InfoRow v-if="supportDoubleCartridge" left="Cartridge Mode" :right="doubleCartridgeModeText"/>
                <InfoRow v-if="supportTripleCartridge" left="Cartridge Mode" :right="tripleCartridgeModeText"/>
              </div>
            </div>
            <!-- Preheat -->
            <div class="info-item" v-if="false">
              <div class="info-title">
                Preheat
                <van-switch
                    style="margin-left:auto;"
                    v-model="writerSetting.isSupportPreheat"
                    active-color="#66DCA5"
                    inactive-color="#D6CDF2"
                    size="18"
                    :disabled="true"/>
              </div>
              <div
                  class="item-split"
                  v-show="writerSetting.isSupportPreheat"
              ></div>
              <div class="info-content" v-show="writerSetting.isSupportPreheat">
                <InfoRow left="Time" :right="`${(writerSetting.preheatTime / 1000).toFixed(1)}s`"/>
                <InfoRow left="Voltage" :right=" `${(writerSetting.preheatVoltage / 1000).toFixed(1)}v`"/>
              </div>
            </div>
            <!-- Voltage -->
            <div class="info-item">
              <div class="info-title">{{ curve1Title }}</div>
              <div class="item-split"></div>
              <div class="info-content">
                <div class="voltage-one">
                  <div
                      class="voltage-number"
                      v-for="(item, index) in doubleLeftCurveVoltage.slice(0, voltageCount)"
                      :key="index">
                    <span v-if="outputMode === 0x20">{{ Math.abs(item / 100).toFixed(1) }}{{ unitName }}</span>
                    <span v-else>{{Math.abs(item / 1000).toFixed(1) }}{{ unitName }}</span>
                  </div>
                </div>
                <div class="voltage-two" style="width:100%;height:calc(20vh)">
                  <van-slider
                      v-for="(value, index) in doubleLeftCurveVoltage.slice(0, voltageCount)"
                      :key="index"
                      v-model="doubleLeftCurveVoltage[index]"
                      vertical
                      :min="dragValue.max"
                      :max="dragValue.min"
                      :step="dragValue.step"
                      bar-height="4px"
                      active-color="#EEEEEE"
                      inactive-color="#D6CDF2"
                      :disabled="true"
                  >
                    <template #button>
                      <img
                          class="slider-button"
                          src="@/assets/icons/icon_slider_button_disabled.png"
                      />
                    </template>
                  </van-slider>
                </div>
                <div class="voltage-three" v-if="false">
                  <div class="voltage-number" v-for="index of voltageCount" :key="index">
                    {{ index }}s
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Voltage 2-->
          <div
              class="info-item"
              v-if="supportDoubleCartridge && isReadDoubleCartridgeMode"
          >
            <div class="info-title">
              {{ curve2Title }}
            </div>
            <div class="item-split"></div>
            <div class="info-content">
              <div class="voltage-one">
                <div
                    class="voltage-number"
                    v-for="(item, index) in doubleRightCurveVoltage.slice(0, voltageCount)"
                    :key="index"
                >
                  <span v-if="outputMode === 0x20">
                    {{ Math.abs(item / 100).toFixed(1) }}{{ unitName }}</span
                  >
                  <span v-else
                  >{{ Math.abs(item / 1000).toFixed(1) }}{{ unitName }}</span
                  >
                </div>
              </div>
              <div class="voltage-two" style="width:100%;height:calc(20vh)">
                <van-slider
                    v-for="(value, index) in doubleRightCurveVoltage.slice(0, voltageCount)"
                    :key="index"
                    v-model="doubleRightCurveVoltage[index]"
                    vertical
                    :min="dragValue.max"
                    :max="dragValue.min"
                    :step="100"
                    bar-height="4px"
                    active-color="#EEEEEE"
                    inactive-color="#D6CDF2"
                    :disabled="true"
                >
                  <template #button>
                    <img
                        class="slider-button"
                        src="@/assets/icons/icon_slider_button_disabled.png"
                    />
                  </template>
                </van-slider>
              </div>
              <div class="voltage-three" v-if="false">
                <div class="voltage-number" v-for="index of voltageCount" :key="index">
                  {{ index }}s
                </div>
              </div>
            </div>
          </div>

          <div style="font-size:14px;" v-else-if="outputMode === 0x40">
            <!-- Info -->
            <div class="info-item">
              <div class="info-title">
                Device Info
              </div>
              <div class="item-split"></div>
              <div class="info-content">
                <InfoRow left="Device Model" :right="insertDeviceName"/>
                <InfoRow left="ID" :right="deviceIdentify"/>
                <InfoRow v-if="deviceType" left="Device Type" :right="deviceType"/>
                <InfoRow left="Resistance" :right="`${resistance}Ω`"/>
                <InfoRow left="Production Time" :right="productTime"/>
                <InfoRow left="Brand" :right="brandName"/>
              </div>
              <div class="info-content" v-if="supportTripleCartridge">
                <!--        Left Base R1      -->
                <InfoRow left="Push Power" :right="`${writerSetting.micSensitivity.toFixed(2)}W`"/>
                <InfoRow :left="r1Title" :right="`${r1}Ω`"/>
                <!--        Left R2      -->
                <InfoRow v-if="showInfoIfExistsR1" :left="r2Title"
                         :right="`${(deviceLeftR2 / 1000 + r1).toFixed(3)}Ω`"/>
                <InfoRow left="Temperature" :right="`${calcT2(r1, deviceLeftR2 / 1000)}°C`"/>

                <!--        Center Base R1      -->
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" :left="centerR1Title" :right="`${centerR1}Ω`"
                />
                <!--        Center R2      -->
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" :left="centerR2Title"
                         :right="`${(deviceTripleCenterR2 / 1000 + centerR1).toFixed(3)}Ω`"/>
                <!--        Center Temperature      -->
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" left="Temperature"
                         :right="`${calcT2(centerR1, deviceTripleCenterR2 / 1000)}°C`"/>

                <!--        Right Base R1      -->
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" :left="doubleR1Title" :right="`${rightR1}Ω`"/>
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" :left="doubleR2Title"
                         :right="`${(deviceTripleRightR2 / 1000 + rightR1).toFixed(3)}Ω`"/>
                <InfoRow v-if="showInfoIfExistsDoubleR1Triple" left="Temperature"
                         :right="`${calcT2(rightR1, deviceTripleRightR2 / 1000)}°C`"/>
              </div>
              <div v-else>
                <div class="info-content">
                  <InfoRow left="Push Power" :right="`${(writerSetting.diyVoltage[2] / 100).toFixed(2)}W`"/>
                  <InfoRow :left="r1Title" :right="r1Value"/>
                  <InfoRow :left="r2Title" :right="`${(deviceLeftR2 / 1000 + r1).toFixed(3)}Ω`"/>
                  <InfoRow left="Temperature" :right="`${calcT2(r1, deviceLeftR2 / 1000)}°C`"/>
                </div>

                <div class="info-content" v-if="supportDoubleCartridge">
                  <InfoRow left="Push Power" :right="`${(writerSetting.diyVoltage[5] / 100).toFixed(2)}W`"/>
                  <InfoRow :left="doubleR1Title" :right="`${(writerSetting.touchSensitivity / 100).toFixed(3)}Ω`"/>
                  <InfoRow :left="doubleR2Title" :right="`${(deviceRightR2 / 1000 + doubleR1).toFixed(3)}Ω`"/>
                  <InfoRow left="Temperature" :right="`${calcT2(doubleR1, deviceRightR2 / 1000)}°C`"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="loadDeviceSettingStatus === 0" class="error-info">
          <div class="device-error-msg">{{ errorMessage }}</div>
          <div class="try-again" @click="reloadDeviceSetting">
            Try again
          </div>
        </div>
        <div v-else class="popup-content info-device-load">
          <van-loading size="60px"/>
        </div>
      </div>
    </div>

    <div
        v-show="selectModel === 'Device' && this.loadDeviceSettingStatus == 1"
        class="footer"
    >
      <van-button class="footer-button" type="default" @click="onClickApply">
        Apply to homepage
      </van-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import { WriterSetting } from "@/bluetooth/BluetoothData";
import {
  isBtDeviceSupportLevel, isBtDeviceSupportOutputDuration,
  isSupportDoubleCartridge,
  isSupportTripleCartridge
} from "@/util/utils";
import store from "@/store";
import StoreType, { BLUETOOTH_MODULE_NAME } from "@/bluetooth/store/StoreType";
import InfoRow from "@/components/InfoRow.vue";
import { voltageNumber } from "@/util/utils";

export default {
  name      : "SettingView",
  components: { InfoRow },
  data() {
    return {
      selectModel            : "Wave Writer",
      hubSetting             : this.getHubSetting(),
      loadDeviceSettingStatus: 2,
      errorMessage           : "",
      connectTimeoutId       : -1
    };
  },
  created() {
  },
  mounted() {
  },
  watch   : {},
  computed: {
    ...mapState({
      macAddress : state => state.bluetooth.macAddress,
      isConnected: state => state.bluetooth.isConnected
    }),
    ...mapState("bluetooth", [
      "deviceId",
      "insertDeviceName",
      "writerSetting",
      "writerSetting2",
      "unitName",
      "dragValue",
      "r1",
      "doubleR1",
      "tripleR1",
      "outputMode",
      "hubOutputMode",
      "hubUnitName",
      "hubDragValue"
    ]),
    ...mapState("bluetooth", {
      centerR1: state => state.doubleR1,
      rightR1 : state => state.tripleR1
    }),

    voltageCount() {
      return voltageNumber(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    supportTripleCartridge() {
      return isSupportTripleCartridge(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    r1Value() {
      return `${(this.writerSetting.micSensitivity / 100).toFixed(3)}Ω`;
    },

    hubLeftR2() {
      return (
          ((this.hubSetting.diyVoltage[1] / 100) << 8) |
          (this.hubSetting.diyVoltage[0] / 100)
      );
    },

    hubRightR2() {
      return (
          ((this.hubSetting.diyVoltage[4] / 100) << 8) |
          (this.hubSetting.diyVoltage[3] / 100)
      );
    },
    tripleHubCenterR2() {
      return (
          ((this.hubSetting.diyVoltage[3] / 100) << 8) |
          (this.hubSetting.diyVoltage[2] / 100)
      );
    },
    tripleHubRightR2() {
      return (
          ((this.hubSetting.diyVoltage[5] / 100) << 8) |
          (this.hubSetting.diyVoltage[4] / 100)
      );
    },
    deviceLeftR2() {
      return (
          ((this.writerSetting.diyVoltage[1] / 100) << 8) |
          (this.writerSetting.diyVoltage[0] / 100)
      );
    },

    deviceTripleCenterR2() {
      return (
          ((this.writerSetting.diyVoltage[3] / 100) << 8) |
          (this.writerSetting.diyVoltage[2] / 100)
      );
    },

    deviceTripleRightR2() {
      return (
          ((this.writerSetting.diyVoltage[5] / 100) << 8) |
          (this.writerSetting.diyVoltage[4] / 100)
      );
    },

    deviceRightR2() {
      return (
          ((this.writerSetting.diyVoltage[4] / 100) << 8) |
          (this.writerSetting.diyVoltage[3] / 100)
      );
    },

    showInfoIfExistsR1() {
      return this.r1 !== 0;
    },
    showInfoIfExistsDoubleR1() {
      return this.doubleR1 !== 0 && this.supportDoubleCartridge;
    },
    showInfoIfExistsDoubleR1Triple() {
      return this.doubleR1 !== 0 && this.supportTripleCartridge;
    },
    showInfoIfExistsDoubleR2Triple() {
      return this.doubleR2 !== 0 && this.supportTripleCartridge;
    },
    deviceVoltage() {
      const deviceCurve = this.writerSetting.diyVoltage
          .map(item => item * -1)
          .slice(0, this.voltageCount);
      return deviceCurve;
    },
    hubInfo() {
      const hubUnit = {
        unitName  : "",
        curveTitle: "",
        dragValue : {
          max: -4200,
          min: -100
        }
      };
      const mode    = this.hubSetting.touchSensitivity;
      console.log(mode);
      switch (mode) {
        case 0:
        case 0x10:
          hubUnit.curveTitle = "Voltage Curve";
          hubUnit.unitName   = "v";
          hubUnit.dragValue  = {
            max : -4200,
            min : -100,
            step: 100
          };
          break;
        case 0x20:
          hubUnit.curveTitle = "Power Curve";
          hubUnit.unitName   = "w";
          hubUnit.dragValue  = {
            max : -1500,
            min : -10,
            step: 10
          };
          break;
        case 0x40:
          break;
        default:
          hubUnit.curveTitle = "Voltage Curve";
          hubUnit.unitName   = "v";
          hubUnit.dragValue  = {
            max : -4200,
            min : -100,
            step: 100
          };
          break;
      }
      return hubUnit;
    },
    deviceVoltage2() {
      const deviceCurve = this.writerSetting2.diyVoltage
          .map(item => item * -1)
          .slice(0, this.voltageCount);
      return deviceCurve;
    },
    hubVoltage() {
      return this.hubSetting.diyVoltage.slice(0, this.voltageCount).map((item, index) => {
        if (index === 0) {
          item = ((item / 100) & 0x3f) * 100;
        }
        return item * -1;
      });
    },
    deviceType() {
      if (this.deviceId) {
        switch (this.deviceId.type) {
          case 1:
            return "Disposable";
          case 3:
            return "Pod Battery";
          case 5:
            return "510 Battery";
        }

        return "";
      }
      return "";
    },

    brandName() {
      if (this.deviceId) {
        switch (this.deviceId.productManufacture) {
          case 0:
            return "AVD";
          case 1:
            return "iKrusher";
          case 2:
            return "Unicore";
          case 3:
            return "HS";
          case 4:
            return "XS";
        }
      }
      return "";
    },

    supportLevel() {
      return isBtDeviceSupportLevel(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },

    supportOutputDuration() {
      return isBtDeviceSupportOutputDuration(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    supportDoubleCartridge() {
      return isSupportDoubleCartridge(
          this.deviceId.productManufacture,
          this.deviceId.productNumber
      );
    },
    doubleCartridgeModeText() {
      if (this.supportDoubleCartridge) {
        const value = this.writerSetting.touchSensitivity & 0x0f;
        switch (value) {
          case 0:
            return "LEFT";
          case 1:
            return "RIGHT";
          case 2: {
            // const c1c2 = this.writerSetting.touchSensitivity >> 4;
            // if (c1c2 === 2) {
            //   return "DOUBLE";
            // } else if (c1c2 === 3) {
            //   return "DOUBLE";
            // }
            return "DOUBLE";
          }
        }
      }
      return "";
    },
    tripleCartridgeModeText() {
      if (this.supportTripleCartridge) {
        const value = this.writerSetting.touchSensitivity & 0x0f;
        switch (value) {
          case 0:
            return "Single";
          case 1:
            return "Double";
          case 2: {
            // const c1c2 = this.writerSetting.touchSensitivity >> 4;
            // if (c1c2 === 2) {
            //   return "DOUBLE";
            // } else if (c1c2 === 3) {
            //   return "DOUBLE";
            // }
            return "Triple";
          }
        }
      }
      return "";
    },
    curve1Title() {
      if (this.writerSetting) {
        const levelFlag = this.writerSetting.touchSensitivity & 0x0f;
        const c1c2      = this.writerSetting.touchSensitivity >> 4;
        if (this.supportDoubleCartridge && levelFlag === 2) {
          //区分哪个是double left
          return "DOUBLE";
        }
      }
      return "Voltage Curve";
    },
    curve2Title() {
      if (this.writerSetting) {
        const levelFlag = this.writerSetting.touchSensitivity & 0x0f;
        const c1c2      = this.writerSetting.touchSensitivity >> 4;
        if (this.supportDoubleCartridge && levelFlag === 2) {
          //区分哪个是double left
          return "DOUBLE ";
        }
      }
      return "Voltage Curve";
    },
    r1Title() {
      if (this.supportDoubleCartridge) {
        return "Left Base R";
      }
      if (this.supportTripleCartridge) {
        return "Left Base R";
      }
      return "R1";
    },
    r2Title() {
      if (this.supportDoubleCartridge) {
        return "Left R2";
      }
      if (this.supportTripleCartridge) {
        return "Left R2";
      }
      return "R2";
    },
    hubR2Value() {
      return `${(this.hubLeftR2 / 1000 + this.r1).toFixed(3)}Ω`;
    },
    tripleCenterValue() {
      return `${(this.centerR / 1000 + this.r1).toFixed(3)}Ω`;
    },
    centerR1Title() {
      if (this.supportTripleCartridge) {
        return "Center Base R";
      }
      return "";
    },
    doubleR1Title() {
      if (this.supportDoubleCartridge) {
        return "Right Base R";
      }
      if (this.supportTripleCartridge) {
        return "Right Base R";
      }
      return "";
    },
    centerR2Title() {
      if (this.supportTripleCartridge) {
        return "Center R2";
      }
      return "";
    },
    doubleR2Title() {
      if (this.supportDoubleCartridge) {
        return "Right R2";
      }
      if (this.supportTripleCartridge) {
        return "Right R2";
      }
      return "";
    },
    doubleLeftCurveVoltage() {
      if (this.isReadDoubleCartridgeMode) {
        const c1OrC2_01 = this.writerSetting.touchSensitivity >> 4;
        if (c1OrC2_01 === 2) {
          return this.deviceVoltage;
        } else {
          return this.deviceVoltage2;
        }
      }
      return this.deviceVoltage;
    },
    doubleRightCurveVoltage() {
      if (this.isReadDoubleCartridgeMode) {
        const c1OrC2_01 = this.writerSetting.touchSensitivity >> 4;
        if (c1OrC2_01 === 3) {
          return this.deviceVoltage;
        } else {
          return this.deviceVoltage2;
        }
      }
      return this.deviceVoltage;
    },
    isReadDoubleCartridgeMode() {
      if (this.supportDoubleCartridge && this.writerSetting2) {
        const levelFlag = this.writerSetting2.touchSensitivity & 0x0f;
        const c1c2      = this.writerSetting2.touchSensitivity >> 4;
        console.log(`mode = ${levelFlag}, c1c2=${c1c2}`);
        if (levelFlag === 2 && (c1c2 === 3 || c1c2 === 2)) {
          return true;
        }
      }
      return false;
    },
    deviceIdentify() {
      if (this.deviceId) {
        return this.deviceId.deviceNumberHex;
      }
      return "";
    },
    //如果是nord的话，直接显示为1.2阻值
    resistance() {
      if (this.deviceId) {
        if (
            this.insertDeviceName &&
            this.insertDeviceName.toUpperCase() === "NORD"
        ) {
          return "1.2";
        }
        const r = this.deviceId.atomizedR;
        return `${(r / 10).toFixed(1)}`;
      }
      return "";
    },
    productTime() {
      if (this.deviceId) {
        const year = this.deviceId.productYear;
        const week = this.deviceId.productWeek;

        return `week ${week}, 20${year.toString(16)}`;
      }
      return "";
    },
    outputDuration() {
      return `${((this.writerSetting.micSensitivity * 10) / 1000).toFixed(2)}s`;
    }
  },
  methods : {
    ...mapGetters("bluetooth", ["getHubSetting"]),
    ...mapState("bluetooth", ["materialType", "doubleMaterialType"]),
    calcT2(r1, r2) {
      let t = 880;
      switch (this.materialType) {
        case 1:
          t = 880;
          break;
        case 2:
          t = 734;
          break;
      }
      const TCR = t * Math.pow(10, -6);
      const T1  = 25;
      const T2  = r2 / TCR / r1 + T1;
      console.log(`t === ${t}, TCR = ${TCR}, r2 ==== ${r2}  ,T2 ==== ${T2}`);
      return T2.toFixed(0);
    },
    onClickHeaderReturn() {
      this.$router.go(-1);
    },
    onClickApply() {
      this.applyToHomePage();
    },
    //应用回首页
    applyToHomePage() {
      const deviceSetting = this.writerSetting;
      if (this.outputMode === 0x40) {
        if (this.supportTripleCartridge) {
          deviceSetting.temperature  = this.calcT2(this.r1, this.deviceLeftR2 / 1000);
          deviceSetting.temperature2 = this.calcT2(this.centerR1, this.deviceTripleCenterR2 / 1000);
          deviceSetting.temperature3 = this.calcT2(this.rightR1, this.deviceTripleRightR2 / 1000);
          deviceSetting.pushPower    = deviceSetting.micSensitivity;
        } else {
          deviceSetting.temperature = this.calcT2(
              this.r1,
              this.deviceLeftR2 / 1000
          );
          deviceSetting.pushPower   = (deviceSetting.diyVoltage[2] / 100).toFixed(
              2
          );
          // deviceSetting.proportion =
          //   ((deviceSetting.diyVoltage[2] / 100) >> 4) & 0x0f;
          // deviceSetting.integral = (deviceSetting.diyVoltage[2] / 100) & 0x0f;
          if (this.supportDoubleCartridge) {
            deviceSetting.temperature2 = this.calcT2(
                this.doubleR1,
                this.deviceRightR2 / 1000
            );
            deviceSetting.pushPower2   = (
                deviceSetting.diyVoltage[5] / 100
            ).toFixed(2);
          }
        }

      }

      const setting = new WriterSetting();
      Object.assign(setting, deviceSetting);

      setting.diyVoltage = []
          .concat(deviceSetting.diyVoltage.map(item => item * -1))
          .slice(0, this.voltageCount);
      this.$router.replace({
        name  : "Home",
        params: {
          setting
        }
      });
    },
    //查询设备信息
    async reloadDeviceSetting() {
      try {
        store.commit(
            `${BLUETOOTH_MODULE_NAME}${StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING}`,
            null
        );
        store.commit(
            `${BLUETOOTH_MODULE_NAME}${StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING2}`,
            null
        );
        this.loadDeviceSettingStatus = 2; //转圈加载
        //加入超时
        let isTimeout         = false;
        this.connectTimeoutId = setTimeout(() => {
          this.handleError("Read timeout");
          isTimeout = true;
        }, 3000);
        await bluetoothRepository.queryWriter(0);
        clearTimeout(this.connectTimeoutId);
        // const needReadTwice = this.writerSetting.touchSensitivity & 0x0f;
        // if (needReadTwice === 2 && !isTimeout) {
        //   //加入超时
        //   this.connectTimeoutId = setTimeout(() => {
        //     this.handleError("Read timeout");
        //   }, 3000);
        //   await bluetoothRepository.queryWriter(1);
        //   clearTimeout(this.connectTimeoutId);
        // }
        this.loadDeviceSettingStatus = 1; //加载成功
      } catch (e) {
        this.handleError(e);
      }
    },
    //处理错误以及超时
    handleError(e) {
      clearTimeout(this.connectTimeoutId);
      if (!this.isConnected) {
        this.errorMessage            = "Device Disconnected";
        this.loadDeviceSettingStatus = 0; //加载失败
        return;
      }
      //提示用户失败了
      if (typeof e === "string") {
        this.errorMessage = e;
      } else {
        this.errorMessage = "Read device info failure!";
      }
      this.loadDeviceSettingStatus = 0; //加载失败
    },
    async onClickSelectModel(model) {
      if (this.selectModel === model) return;
      this.selectModel = model;
      if (model === "Device") {
        //如果是device的时候，转圈加载完在显示
        this.reloadDeviceSetting();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background: #f8f6ff;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .header {
    width: 100%;
    height: 60px;
    min-height: 60px;
    background: #6649c4;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    font-weight: bold;
    color: #ffffff;

    .header-return {
      position: absolute;
      left: 10px;
    }
  }

  .content {
    height: 100%;
    padding: 0 16px;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    margin-bottom: 60px;

    .setting-model {
      margin: 16px 0;
      display: flex;
      align-items: center;

      .model-button {
        height: 50px;
        background: #f8f6ff;
        color: #6649c4;
        border: 1px solid #6649c4;
        border-radius: 10px;
        font-size: 18px;
        font-weight: bold;
        width: 50%;
      }

      .model-button-active {
        background: #6649c4;
        color: #ffffff;
      }
    }

    .info-item:first-child {
      margin-top: 0px;
    }

    .info-item:last-child {
      margin-bottom: 16px;
    }

    .info-device-load {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 60px 0;
    }

    .error-info {
      height: 50vh;
      color: #86a1a9;
      display: flex;
      text-align: center;
      justify-content: center;
      flex-direction: column;
      justify-items: center;
      margin-top: 10px;
      font-size: 20px;
      font-weight: 400;
      color: #555555;

      .try-again {
        margin: 0 auto;
        color: #6649c4;
        font-size: 16px;
        width: 120px;
        height: 40px;
        line-height: 40px;
        border: 1px solid #f1edff;
        background: #f1edff;
        border-radius: 20px;
        margin-top: 2vh;
      }
    }

    .info-item {
      background: #ffffff;
      border-radius: 10px;
      margin-top: 16px;

      .info-title {
        font-size: 18px;
        font-weight: bold;
        color: #555555;
        padding: 16px;
        display: flex;
        align-items: center;

        .history-button-apply {
          height: 30px;
          margin: 16px 0 16px auto;
          background: #f1edff;
          color: #6649c4;
          border: none;
          border-radius: 8px;
          white-space: nowrap;
        }
      }

      .info-content {
        display: flex;
        flex-direction: column;
        padding: 0 16px;
        padding-bottom: 16px;

        .info-row {
          width: 100%;
          display: flex;
          margin-top: 16px;

          .info-row-left {
            font-size: 16px;
            font-weight: 400;
            color: #999999;
          }

          .info-row-right {
            margin-left: auto;
            font-size: 16px;
            font-weight: 400;
            color: #555555;
          }
        }

        .voltage-one {
          margin: 16px 0 16px 0;
          display: flex;
          width: 100%;

          div {
            margin: 0 auto;
            font-size: 13px;
            font-weight: 400;
            color: #999999;
          }
        }

        .voltage-two {
          display: flex;
          margin: 8px 0 16px 0;

          .slider-button {
            width: 40px;
            height: 40px;
          }

          /deep/ .van-slider {
            margin: 0 auto;
          }
        }

        .voltage-three {
          display: flex;
          width: 100%;

          div {
            margin: 0 auto;
            font-size: 13px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
  }

  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    min-height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0px -2px 6px 1px rgba(0, 0, 0, 0.149);

    .footer-button {
      widows: calc(100vw - 50px);
      height: 45px;
      background: #6649c4;
      border-radius: 8px;
      border: 1px solid #6649c4;
      font-size: 18px;
      font-weight: normal;
      color: #ffffff;
    }
  }
}
</style>
